export const aboutContent = `Batesky is purpose-built on open protocols that treat people with respect, protect their privacy, and give them real control over their digital social spaces.

Batesky is built on Bluesky and the underlying AT Protocol giving control and ownership back to its users.

**Contact**
You can contact us via email at [hello@batesky.app](mailto:hello@batesky.app) or send us a Direct Message through the Batesky or Bluesky app.
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
&nbsp;
`
